(function(){
  document.addEventListener('change', function(e){
    var sel = e.target.closest && e.target.closest('[data-vselect]');
    if (!sel) return;
    var card = sel.closest('[data-product]'), opt = sel.options[sel.selectedIndex];
    if (!card || !opt) return;
    var id = opt.value;
    card.querySelectorAll('.card__act[data-variant]').forEach(function(s){
      s.hidden = s.getAttribute('data-variant') !== id;
    });
    var pr = card.querySelector('[data-vprice]');
    if (pr) pr.textContent = opt.getAttribute('data-price');
    var cp = card.querySelector('[data-vcompare]');
    if (cp) { var c = opt.getAttribute('data-compare') || ''; cp.textContent = c; cp.hidden = !c; }
  });
})();

(function(){
  document.addEventListener('click', function(e){
    var pill = e.target.closest('[data-vpill]');
    if (!pill || pill.disabled) return;
    var card = pill.closest('[data-product]');
    if (!card) return;
    var id = pill.getAttribute('data-vpill');
    card.querySelectorAll('[data-vpill]').forEach(function(p){
      var on = p === pill;
      p.classList.toggle('is-on', on);
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    card.querySelectorAll('.card__act[data-variant]').forEach(function(s){
      s.hidden = s.getAttribute('data-variant') !== id;
    });
    var pr = card.querySelector('[data-vprice]');
    if (pr) pr.textContent = pill.getAttribute('data-price');
    var cp = card.querySelector('[data-vcompare]');
    if (cp) { var c = pill.getAttribute('data-compare') || ''; cp.textContent = c; cp.hidden = !c; }
  });
})();

/* lock the page behind the basket pop-up on phones (iOS ignores overflow:hidden, so pin the body) */
(function(){
  var body = document.body, y = 0, locked = false;
  var mobile = window.matchMedia('(max-width:1040px)');
  function set(on){
    if (on === locked) return;
    locked = on;
    if (on) {
      y = window.pageYOffset || document.documentElement.scrollTop || 0;
      body.style.position = 'fixed'; body.style.top = (-y) + 'px';
      body.style.left = '0'; body.style.right = '0'; body.style.width = '100%';
    } else {
      body.style.position = ''; body.style.top = ''; body.style.left = ''; body.style.right = ''; body.style.width = '';
      window.scrollTo(0, y);
    }
  }
  function check(){ set(body.classList.contains('basket-open') && mobile.matches); }
  new MutationObserver(check).observe(body, { attributes: true, attributeFilter: ['class'] });
  if (mobile.addEventListener) mobile.addEventListener('change', check);
})();
/* smarter menu search: product-name matches first, no repeats, and jump to the results */
(function(){
  var input = document.querySelector('[data-menu-search]');
  if (!input) return;
  var timer = null;
  function variants(w){
    var v = [w];
    if (w.length > 3) v.push(w.replace(/ies$/, 'y'), w.replace(/es$/, ''), w.replace(/s$/, ''));
    return v;
  }
  // every typed word must match the START of a word in the name ("rusk" finds "Milk Rusk", never "Brusketta")
  function esc(v){ return v.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function hasAll(text, ws){
    return ws.every(function(vs){ return vs.some(function(v){ return v && new RegExp('(^|[^a-z0-9])' + esc(v)).test(text); }); });
  }
  function stickyOffset(){
    var off = 0;
    ['.hdr', '.searchbar', '.mobile-category', '.catbar'].forEach(function(sel){
      var el = document.querySelector(sel);
      if (!el || !el.offsetHeight) return;
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') off = Math.max(off, (parseFloat(cs.top) || 0) + el.offsetHeight);
    });
    return off + 12;
  }
  function run(scroll){
    var q = input.value.trim().toLowerCase();
    var ws = q.split(/\s+/).filter(Boolean).map(variants);
    var cards = [].slice.call(document.querySelectorAll('[data-product]'));
    // if any product NAME matches, show only name matches (so "rusk" shows the rusks, not everything tagged Rusks)
    var byTitle = cards.some(function(c){ return hasAll(c.dataset.title || '', ws); });
    var seen = {}, shown = 0, first = null;
    cards.forEach(function(c){
      var t = c.dataset.title || '';
      var hay = byTitle ? t : t + ' ' + (c.dataset.type || '') + ' ' + (c.dataset.tags || '');
      var hit = hasAll(hay, ws) && !seen[t];
      if (hit) { seen[t] = 1; shown++; if (!first) first = c; }
      c.hidden = !hit;
    });
    [].slice.call(document.querySelectorAll('[data-section]')).forEach(function(sec){
      sec.hidden = !sec.querySelector('[data-product]:not([hidden])');
    });
    var none = document.querySelector('[data-no-results]');
    if (none) none.hidden = shown > 0;
    var cnt = document.querySelector('[data-cat-count]');
    if (cnt) cnt.textContent = shown ? shown + (shown === 1 ? ' item' : ' items') : '';
    if (scroll) {
      var target = first ? (first.closest('[data-section]') || first) : none;
      if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - stickyOffset(), behavior: 'smooth' });
    }
  }
  // take over the search box while there is a query; an empty box falls back to the normal category view
  document.addEventListener('input', function(e){
    if (e.target !== input || !input.value.trim()) return;
    e.stopImmediatePropagation();
    run(false);
    clearTimeout(timer);
    timer = setTimeout(function(){ run(true); }, 600);
  }, true);
  input.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && input.value.trim()) { e.preventDefault(); clearTimeout(timer); run(true); input.blur(); }
  });
})();

/* stock limits: never let a customer add more than we have; show "Only N left" on Treasure Hunt cards */
(function(){
  function slot(id){ return document.querySelector('.card__act[data-variant="' + id + '"]'); }
  // stock = what the shop really has (drives the "Only N left" badge)
  function maxOf(id){ var s = slot(id); if (!s || s.getAttribute('data-max') === null) return Infinity; return Math.max(0, parseInt(s.getAttribute('data-max'), 10) || 0); }
  // cap = most ONE customer may put in their basket (Treasure Hunt: 1 per customer, whatever the stock)
  function capOf(id){ var s = slot(id), stock = maxOf(id); if (!s || s.getAttribute('data-cap') === null) return stock; return Math.min(stock, Math.max(0, parseInt(s.getAttribute('data-cap'), 10) || 0)); }
  function limited(id){ var s = slot(id); return !!s && s.getAttribute('data-cap') !== null && capOf(id) < maxOf(id); }
  function qtyOf(id){ var n = document.querySelector('[data-vnum="' + id + '"]'); return n ? (parseInt(n.textContent, 10) || 0) : 0; }
  var toastEl = null, toastT = null;
  function toast(msg){
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'stocktoast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 2200);
  }
  function refresh(){
    document.querySelectorAll('[data-vqty][data-step="1"]').forEach(function(b){
      var id = b.getAttribute('data-vqty'), full = qtyOf(id) >= capOf(id);
      b.classList.toggle('is-max', full); b.setAttribute('aria-disabled', full ? 'true' : 'false');
    });
    document.querySelectorAll('[data-vleft]').forEach(function(lbl){
      var card = lbl.closest('[data-product]');
      var act = card && card.querySelector('.card__act[data-variant]:not([hidden])');
      if (!act || act.getAttribute('data-max') === null) { lbl.hidden = true; return; }
      var id = act.getAttribute('data-variant'), max = maxOf(id), left = max - qtyOf(id);
      var txt = left > 0 ? 'Only ' + left + ' left' : 'All ' + max + ' in your basket';
      if (limited(id) && qtyOf(id) >= capOf(id)) txt = 'Limit 1 per customer · in your basket';
      lbl.hidden = false;
      if (lbl.textContent !== txt) lbl.textContent = txt;   // only touch the page when something changed
      lbl.classList.toggle('is-out', left <= 0);
    });
  }
  function blockedId(t){
    var add = t.closest && t.closest('[data-add]'), id = add ? add.getAttribute('data-add') : null;
    if (!id) { var st = t.closest && t.closest('[data-vqty]'); if (st && st.getAttribute('data-step') === '1') id = st.getAttribute('data-vqty'); }
    return id && qtyOf(id) >= capOf(id) ? id : null;
  }
  // runs before the basket's own handlers, so the extra tap never reaches the cart
  ['pointerdown', 'click'].forEach(function(type){
    document.addEventListener(type, function(e){
      var id = blockedId(e.target);
      if (id) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (type === 'pointerdown') {
          var m = maxOf(id), c = capOf(id);
          if (limited(id)) toast('Sorry, you can buy only ' + c + ' of this product per customer');
          else toast(m > 0 ? 'Sorry, only ' + m + ' available' : 'Sorry, this is sold out');
        }
      }
    }, true);
  });
  var queued = false;
  new MutationObserver(function(){ if (queued) return; queued = true; requestAnimationFrame(function(){ queued = false; refresh(); }); })
    .observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('click', function(e){ if (e.target.closest('[data-vpill]')) setTimeout(refresh, 0); });
  document.addEventListener('change', function(e){ if (e.target.closest && e.target.closest('[data-vselect]')) setTimeout(refresh, 0); });
  refresh();
})();